import React from 'react';
import Zoom from 'react-medium-image-zoom';

const title = "Trial Balance";
const description = `The Trial Balance is an internal accounting report generated at the end of a specific period that lists the ending balance of every single account from the General Ledger. The report is structured with two columns—one for all Debit balances and one for all Credit balances. Its primary purpose is to test the mathematical accuracy of the double-entry system by confirming that the total of all debit column balances is exactly equal to the total of all credit column balances before any official financial statements are prepared.`;

const images = [
    '/images/reports/purchase-by-supplier/purchase-by-supplier.png', // 0
];


const TrialBalance: React.FC = () => {

    return (
        <div className="max-w-4xl lg:max-w-5xl min-h-screen bg-gray-50 flex gap-2">
            <div className="overflow-auto mx-auto flex-2">

                <div className="mb-6">
                    <h1 className="text-3xl font-bold pt-4 text-gray-900">
                        {title}
                    </h1>
                    <p className="text-gray-600 mt-4">
                        {description}
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 my-6">
                        <Zoom>
                            <img
                                src={images[0]}
                                alt={title}
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>
                        </Zoom>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TrialBalance;
